import { H_REFERENCIAL_CONTRIBUTOR } from 'account/constants/AccessRulesConstants'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { REFERENCIAL_TYPE_NAME } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import ContributorAction from '../actions/ContributorAction'
import { Box } from '@mui/material'
import { PATH_REFERENCIAL_RPQS_LINK } from 'home/constants/RouteConstants'

const ContributorGroupRouterApp = ({ rpqs }) => {
    const dispatch = useDispatch()
    const { code } = useParams()

    const navLinks = useMemo(() => {
        if (rpqs) {
            return [{
                icons: 'dashboard',
                name: i18n.dashboard,
                href: `${PATH_REFERENCIAL_RPQS_LINK}contributorGroup/${code}/dashboard`,
                habilitation: H_REFERENCIAL_CONTRIBUTOR,
            }].filter(l => componentHasHabilitations(l.habilitation))
        }
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: `/referencial/${REFERENCIAL_TYPE_NAME.contributorGroup}/${code}/dashboard`,
            habilitation: H_REFERENCIAL_CONTRIBUTOR,
        }].filter(l => componentHasHabilitations(l.habilitation))
    }, [code, rpqs])

    useEffect(() => {
        dispatch(ContributorAction.fetchContributorsGroups())
        if (code !== 'new') {
            dispatch(ContributorAction.fetchContributorsGroup(code))
        }
    }, [code, dispatch])

    return (
        <Box>
            <FixedSlideNav links={navLinks} />
            <Box className='content-page fullscreen' padding={1}>
                <BoundaryError>
                    <Outlet />
                </BoundaryError>
            </Box>
        </Box>
    )
}

ContributorGroupRouterApp.propTypes = {
    rpqs: PropTypes.bool,
}

export default ContributorGroupRouterApp